import React from 'react';
import 'react-big-calendar/lib/css/react-big-calendar.css';
import { Route, BrowserRouter as Router, Routes } from 'react-router-dom';
import EventsLayout from './components/layouts/EventsLayout/EventsLayout';
import MainLayout from './components/layouts/mainLayout/MainLayout';
import AccountItem from './pages/AccountItem';
import AccountsList from './pages/AccountsList';
import ContactItem from './pages/ContactItem';
import ContactsList from './pages/ContactsList';
import Dashboard from './pages/Dashboard';
import EmailTemplateItem from './pages/EmailTemplateItem';
import EmailTemplatesList from './pages/EmailTemplatesList';
import EmployeeItem from './pages/EmployeeItem';
import EmployeesList from './pages/EmployeesList';
import EventItem from './pages/EventItem';
import EventTemplateItem from './pages/EventTemplateItem';
import EventTemplatesList from './pages/EventTemplatesList';
import ForgotPassword from './pages/ForgotPassword';
import { GoogleOAuthCallback } from './pages/GoogleOAuthCallback';
import GoogleOAuthRedirect from './pages/GoogleOAuthRedirect';
import Integrations from './pages/Integrations';
import NotFoundPage from './pages/NotFoundPage';
import Organization from './pages/Organization';
import OutlookOAuthCallback from './pages/OutlookOAuthCallback';
import OutlookOAuthRedirect from './pages/OutlookOAuthRedirect';
import Preferences from './pages/Preferences';
import ResetPassword from './pages/ResetPassword';
import SignIn from './pages/SignIn';
import SignUp from './pages/SignUp';
import TaskItem from './pages/TaskItem';
import TaskList from './pages/TasksList';
import TaskTemplateItem from './pages/TaskTemplateItem';
import TaskTemplatesList from './pages/TaskTemplateList';
import UserRoleItem from './pages/UserRoleItem';
import UserRolesList from './pages/UserRolesList';
import UserSettings from './pages/UserSettings';
import { ROUTE_PATHS } from './routes/Routes';
import './styles/main.sass';
import CreateAccount from './pages/CreateAccount';
import { Actions } from './services/react-query/permissions';
import { disableWrappedPage } from './contexts/DisableContextProvider';

const RootComponent: React.FC = () => {
  return (
    <Router>
      <Routes>
        <Route path={ROUTE_PATHS.LOGIN} element={<SignIn />} />
        <Route path={ROUTE_PATHS.FORGOT_PASSWORD} element={<ForgotPassword />} />
        <Route path={ROUTE_PATHS.RESET_PASSWORD} element={<ResetPassword />} />
        <Route path={ROUTE_PATHS.SIGN_UP} element={<SignUp />} />
        <Route path={ROUTE_PATHS.CREATE_ACCOUNT} element={<CreateAccount />} />
        <Route path="/" element={<MainLayout />}>
          <Route path={ROUTE_PATHS.NOT_FOUND} element={<NotFoundPage />} />
          <Route path={ROUTE_PATHS.DASHBOARD} element={<Dashboard />} />
          <Route path={ROUTE_PATHS.ACCOUNTS} element={<AccountsList />} />
          <Route path={ROUTE_PATHS.ACCOUNT_ITEM} element={disableWrappedPage(AccountItem, Actions.ACCOUNTS_WRITE)} />
          <Route path={ROUTE_PATHS.CONTACTS} element={<ContactsList />} />
          <Route path={ROUTE_PATHS.CONTACT_ITEM} element={disableWrappedPage(ContactItem, Actions.CONTACTS_WRITE)} />
          <Route path={ROUTE_PATHS.USER_ROLES} element={<UserRolesList />} />
          <Route path={ROUTE_PATHS.UER_ROLE_ITEM} element={disableWrappedPage(UserRoleItem, Actions.USER_ROLES_WRITE)} />
          <Route path={ROUTE_PATHS.EMPLOYEES} element={<EmployeesList />} />
          <Route path={ROUTE_PATHS.EMPLOYEE_ITEM} element={disableWrappedPage(EmployeeItem, Actions.EMPLOYEES_WRITE)} />
          <Route path={ROUTE_PATHS.EVENTS} element={<EventsLayout />} />
          <Route path={ROUTE_PATHS.EVENTS_TABLE} element={<EventsLayout />} />
          <Route path={ROUTE_PATHS.EVENTS_CALENDAR} element={<EventsLayout />} />
          <Route path={ROUTE_PATHS.EVENT_ITEM} element={disableWrappedPage(EventItem, Actions.EVENTS_WRITE)} />
          <Route path={ROUTE_PATHS.TASKS} element={<TaskList />} />
          <Route path={ROUTE_PATHS.TASK_ITEM} element={disableWrappedPage(TaskItem, Actions.TASKS_WRITE)} />
          <Route path={ROUTE_PATHS.EVENT_TEMPLATES} element={<EventTemplatesList />} />
          <Route path={ROUTE_PATHS.EVENT_TEMPLATE_ITEM} element={disableWrappedPage(EventTemplateItem, Actions.EVENT_TEMPLATES_WRITE)} />
          <Route path={ROUTE_PATHS.TASK_TEMPLATES} element={<TaskTemplatesList />} />
          <Route path={ROUTE_PATHS.TASK_TEMPLATE_ITEM} element={disableWrappedPage(TaskTemplateItem, Actions.TASK_TEMPLATES_WRITE)} />
          <Route path={ROUTE_PATHS.EMAIL_TEMPLATES} element={<EmailTemplatesList />} />
          <Route path={ROUTE_PATHS.EMAIL_TEMPLATE_ITEM} element={disableWrappedPage(EmailTemplateItem, Actions.EMAIL_TEMPLATES_WRITE)} />
          <Route path={ROUTE_PATHS.USER_SETTINGS} element={<UserSettings />} />
          <Route path={ROUTE_PATHS.PREFERENCES} element={<Preferences />} />
          <Route path={ROUTE_PATHS.ORGANIZATION} element={disableWrappedPage(Organization, Actions.ORGANIZATION_WRITE)} />
          <Route path={ROUTE_PATHS.INTEGRATIONS} element={<Integrations />} />
          <Route path={ROUTE_PATHS.OAUTH_REDIRECT_GOOGLE} element={<GoogleOAuthRedirect />} />
          <Route path={ROUTE_PATHS.OAUTH_CALLBACK_GOOGLE} element={<GoogleOAuthCallback />} />
          <Route path={ROUTE_PATHS.OAUTH_REDIRECT_OUTLOOK} element={<OutlookOAuthRedirect />} />
          <Route path={ROUTE_PATHS.OAUTH_CALLBACK_OUTLOOK} element={<OutlookOAuthCallback />} />
        </Route>
      </Routes>
    </Router>
  );
};

export default RootComponent;
